import { render, staticRenderFns } from "./SatgasReportCNT.vue?vue&type=template&id=07b2cce3"
import script from "./SatgasReportCNT.vue?vue&type=script&lang=js"
export * from "./SatgasReportCNT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports